import { useMemo, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	useGetKvsSamagamQuery,
	useGetTotalTeacherAttendanceQuery,
	useGetTotalStudentsQuery,
	useGetTotalRegisteredEmpQuery,
	useGetTotalPMSHRIQuery,
	useGetResult10To12SummaryQuery,
	useGetTodaysDetailedAttendanceQuery,
} from '../services/api';
import { useGetKvsResultAllClassSummaryQuery } from '../../student-holistic/services/kvsResultApi';
import { useGetAdmittedSummaryQuery } from '../../admission/services/admittedAnalyticsApi';
import KVSLoader from '../../../components/loaders/KVSLoader';
import { setSchoolCounts } from '../../../../store/slices/pmShriConstantsSlice';
import Header from '../../../components/header/Header';
import Footer from '../../../components/footer/Footer';
import HeroCarousel from '../../../components/carousel/HeroCarousel';
import img1 from '../../../assets/ld1.webp';
import img2 from '../../../assets/ld2.png';
import img3 from '../../../assets/ld3.png';
import kvsLogo from '../../../assets/kvsLogo.svg';
import pmshriIcon from '../../../assets/pmshri.svg';
// import dikshaIcon from '../../../assets/diksha.svg';
// import nishthaIcon from '../../../assets/nishtha.svg';
// import udiseIcon from '../../../assets/udise.svg';
import resultIcon from '../../../assets/resultlogo.svg'
import admissionIcon from '../../../assets/school.png'

const initialDashboardCards = [
	{
		title: 'Vidyalayas',
		gradient: 'linear-gradient(135deg, #531D63 0%, #852D91 100%)',
		textColor: '#6A1786',
		icon: kvsLogo,
		route: '/kvs-samagam/schools',
		stats: [
			{ label: 'Total Schools', value: '--' },
			{ label: "Total KV's", value: '--' }
		],
		button: 'Know More >>'
	},
	{
		title: 'Student Performance',
		gradient: 'linear-gradient(135deg, #005A5A 0%, #BBFED5 100%)',
		textColor: '#005A5A',
		icon: resultIcon,
		route: '/student-analytics/stages',
		stats: [
			{ label: 'Total Students', value: '--' },
		],
		button: 'Know More >>'
	},
	{
		title: 'Attendance',
		gradient: 'linear-gradient(135deg, #878FFE 50%, #5CD5FE 100%)',
		textColor: '#82A956',
		icon: kvsLogo,
		route: '/attendance',
		stats: [
			{ label: 'Teachers', value: ' ' },
			{ label: "Students", value: ' ' }
		],
		button: 'Know More >>'
	},
	{
		title: 'PM SHRI',
		gradient: 'linear-gradient(135deg, #1499A9 0%, #309DDA 100%)',
		textColor: '#1A6C9C',
		icon: pmshriIcon,
		route: '/pm-shri',
		stats: [
			{ label: 'Total Schools', value: '--' },
			{ label: 'Total PMSHRI', value: '--' }
		],
		button: 'Know More >>'
	},
	{
		title: 'CBSE Result',
		gradient: 'linear-gradient(135deg, #FF75BE 0%, #93BCFE 100%)',
		textColor: '#055C66',
		icon: resultIcon,
		route: '/result',
		stats: [
			{ label: '10th Result', value: '3.81L' },
			{ label: '12th Result', value: '3.5L' }
		],
		button: 'Know More >>'
	},
	{
		title: 'Admission',
		gradient: 'linear-gradient(135deg, #B44500 0%, #FF9A3D 100%)',
		textColor: '#B44500',
		icon: admissionIcon,
		route: '/admission',
		stats: [
			{ label: 'Total Admissions', value: '--' }
		],
		button: 'Know More >>'
	},
	//    {
	// 	   title: 'DIKSHA - ETB & eContent',
	// 	   color: 'bg-[#F36B21]',
	// 	   icon: dikshaIcon,
	//        route: '/diksha',
	// 	   stats: [
	// 		   { label: 'Total Content', value: '3.81L' },
	// 		   { label: 'Total ETB’s', value: '7,551' }
	// 	   ],
	// 	   button: 'Know More >>'
	//    },
	//    {
	// 	   title: 'NISHTHA',
	// 	   color: 'bg-[#1DB954]',
	// 	   icon: nishthaIcon,
	//        route: '/nishtha',
	// 	   stats: [
	// 		   { label: 'No of Program', value: '04' },
	// 		   { label: 'No. of beneficiaries', value: '61.48L' }
	// 	   ],
	// 	   button: 'Know More >>'
	//    },
	//    {
	// 	   title: 'UDISE+',
	// 	   color: 'bg-[#3A6FC1]',
	// 	   icon: udiseIcon,
	//        route: '/udise',
	// 	   stats: [
	// 		   { label: 'To. Schools Survey', value: '15.1L' },
	// 		   { label: "Total Teacher's", value: '97L' }
	// 	   ],
	// 	   button: 'Know More >>'
	//    },

];

export default function DashboardPage() {
	const carouselImages = [img1, img2, img3];
	const navigate = useNavigate();
	const dispatch = useDispatch();

	// RTK Query hooks - automatic background refetch, no manual caching needed!
	// Data stays visible during refetch (no blank UI)
	// isFetching indicates background activity
	const { data: kvsSamagamData, isLoading: kvsSamagamLoading } = useGetKvsSamagamQuery();
	const { data: teacherAttendanceData, isLoading: teacherLoading } = useGetTotalTeacherAttendanceQuery();
	const { data: studentAttendanceData, isLoading: studentLoading } = useGetTotalStudentsQuery();
	const { data: todaysAttendanceData, isLoading: todaysAttendanceLoading } = useGetTodaysDetailedAttendanceQuery();
	const { data: pmshriData, isLoading: pmshriLoading } = useGetTotalPMSHRIQuery();
	const { data: allClassSummaryData, isLoading: studentPerformanceLoading } = useGetKvsResultAllClassSummaryQuery({ year: 2026 });
	const { data: resultData, isLoading: resultLoading } = useGetResult10To12SummaryQuery(2025);
	const { data: admissionSummaryData, isLoading: admissionLoading } = useGetAdmittedSummaryQuery();
	
	const total10 = resultData?.class10.totalStudents;
	const total12 = resultData?.class12.totalStudents;

	// Teacher count from PIS API - 1 hour cache, auto-updates on data change
	const { data: registeredEmpData } = useGetTotalRegisteredEmpQuery();

	// Store school counts in Redux for use across the app
	useEffect(() => {
		if (kvsSamagamData && pmshriData) {
			dispatch(setSchoolCounts({
				totalSchools: kvsSamagamData.totalSchools,
				totalKVs: kvsSamagamData.totalKVs,
				totalPMSHRI: pmshriData.totalPMSHRI
			}));
		}
	}, [kvsSamagamData, pmshriData, dispatch]);

	// Memoize formatted values to avoid recalculating on every render
	const formattedTeacherCount = useMemo(() => {
		// Use new PIS API data if available, fallback to attendance API
		if (registeredEmpData?.totalEmployee) {
			return registeredEmpData.totalEmployee.toLocaleString();
		}
		if (teacherAttendanceData !== null && teacherAttendanceData !== undefined) {
			return teacherAttendanceData.toLocaleString();
		}
		return '--';
	}, [registeredEmpData, teacherAttendanceData]);

	const formattedStudentCount = useMemo(() => {
		// Prefer today's present count from /sis/todays-detailed-attendance
		if (todaysAttendanceData?.totalPresent != null) {
			return todaysAttendanceData.totalPresent.toLocaleString();
		}
		// Fallback to enrollment data
		if (!studentAttendanceData) return ' ';
		if (typeof studentAttendanceData === 'object') {
			const data = studentAttendanceData as any;
			const value = data.totalPresent ?? data.totalEnrollment ?? data.totalStudents ?? null;
			return value !== null && value !== undefined ? value.toLocaleString() : '0';
		}
		return (studentAttendanceData as number).toLocaleString();
	}, [todaysAttendanceData, studentAttendanceData]);

	// Total across all four developmental stages — already summed server-side.
	const formattedStudentPerformanceCount = useMemo(() => {
		const total = allClassSummaryData?.data?.overview?.totalStudents || 1215344;
		return total.toLocaleString();
	}, [allClassSummaryData]);

	// Map loading states for individual stats
	const getStatLoadingState = useCallback((cardTitle: string, statLabel: string) => {
		if (cardTitle === 'Vidyalayas') return kvsSamagamLoading;
		if (cardTitle === 'Attendance') {
			return statLabel.toLowerCase().includes('teacher') ? teacherLoading : (todaysAttendanceLoading || studentLoading);
		}
		if (cardTitle === 'PM SHRI') return pmshriLoading;
		if (cardTitle === 'Student Performance') return studentPerformanceLoading;
		if (cardTitle === 'CBSE Result') return resultLoading;
		if (cardTitle === 'Admission') return admissionLoading;
		return false;
	}, [kvsSamagamLoading, teacherLoading, studentLoading, pmshriLoading, studentPerformanceLoading, resultLoading, admissionLoading]);


	// Memoize navigation handlers to prevent re-creation on every render
	const handleTeacherClick = useCallback(() => {
		navigate('/attendance?role=teacher');
	}, [navigate]);

	const handleStudentClick = useCallback(() => {
		navigate('/attendance?role=student');
	}, [navigate]);

	const handleStudentPerformanceClick = useCallback(() => {
		navigate('/student-analytics/stages');
	}, [navigate]);

	// Compute dashboard cards using useMemo - updates only when data changes
	const dashboardCards = useMemo(() => {
		return initialDashboardCards.map(card => {
			if (card.title === 'Vidyalayas' && kvsSamagamData) {
				return {
					...card,
					stats: [
						{ label: 'Total Schools', value: String(kvsSamagamData.totalSchools || '--') },
						{ label: "Total KV's", value: String(kvsSamagamData.totalKVs || '--') }
					]
				};
			}
			if (card.title === 'Attendance') {
				return {
					...card,
					stats: [
						{ label: 'Teachers', value: formattedTeacherCount },
						{ label: 'Students', value: formattedStudentCount }
					]
				};
			}
			if (card.title === 'PM SHRI' && pmshriData && kvsSamagamData) {
				// Format currency in lakhs

				return {
					...card,
					stats: [
						{ label: 'Total Schools', value: String(kvsSamagamData.totalSchools) || '--' },
						{ label: 'Total PMSHRI', value: String(pmshriData.totalPMSHRI) || '--' }
					]
				};
			}
			if (card.title === 'Student Performance') {
				return {
					...card,
					stats: [
						{ label: 'Total Students', value: formattedStudentPerformanceCount }
					]
				};
			}
			if (card.title === 'CBSE Result') {
				return {
					...card,
					stats: [
						{ label: '10th Result', value: total10 != null ? total10.toLocaleString() : '--' },
						{ label: '12th Result', value: total12 != null ? total12.toLocaleString() : '--' }
					]
				};
			}
			if (card.title === 'Admission') {
				return {
					...card,
					stats: [
						{ label: 'Total Admissions', value: admissionSummaryData?.total != null ? admissionSummaryData.total.toLocaleString() : '--' }
					]
				};
			}
			return card;
		});
	}, [kvsSamagamData, formattedTeacherCount, formattedStudentCount, pmshriData, formattedStudentPerformanceCount, total10, total12, admissionSummaryData]);

	return (
		<div className="min-h-screen flex flex-col bg-white">
			<Header />
			{/* Hero Section - Full Width Image Carousel */}
			<HeroCarousel images={carouselImages} autoRotateInterval={3000} />
			{/* Card Grid Section */}
			<section className="w-full py-8 md:py-16 px-4 bg-[#f8fafc]">
				<div className="max-w-[1700px] mx-auto px-4 md:px-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 gap-y-16">
					{dashboardCards.map((card, idx) => (
						<div
							key={idx}
							className={`relative w-full overflow-visible rounded-3xl p-8 flex flex-col items-center text-white shadow-2xl transition-all duration-500 group transform hover:-translate-y-2 border border-white/20`}
							style={{
								minHeight: '360px',
								background: card.gradient || 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(0,0,0,0.2) 100%)',
							}}
						>
							{/* Animated Background Pattern mimicking the reference */}
							<div className="absolute inset-0 overflow-hidden rounded-3xl opacity-10 pointer-events-none">
								<div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full transform translate-x-8 -translate-y-16 group-hover:scale-150 transition-transform duration-700"></div>
								<div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full transform -translate-x-6 translate-y-12 group-hover:scale-125 transition-transform duration-700"></div>
								<div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
							</div>

							<div className="flex flex-col items-center mb-6 relative w-full z-10">
								<div
									className="bg-white/20 backdrop-blur-sm rounded-full p-2 flex items-center justify-center -mt-16 group-hover:scale-125 transition-all duration-500 shadow-xl border border-white/30"
									style={{
										width: '100px',
										height: '100px',
									}}
								>
									{/* Inner white circle for the logo to pop against the glass */}
									<div className="bg-white rounded-full w-full h-full p-2 flex items-center justify-center">
										<img
											src={card.icon}
											alt={card.title + ' Logo'}
											className="h-full w-full object-contain"
										/>
									</div>
								</div>
								<div className="text-center mt-4">
									<p className="text-white/80 text-sm font-medium tracking-wider uppercase mb-1">Overview</p>
									<span className="font-extrabold text-xl md:text-2xl tracking-wide drop-shadow-sm">{card.title}</span>
								</div>
							</div>
							
							<div className="flex flex-row w-full gap-3 mb-4 justify-center z-10">
								{card.stats.map((stat, sidx) => {
									const isLoading = getStatLoadingState(card.title, stat.label);
									
									// For Attendance card, make Teacher/Student boxes clickable
									if (card.title === 'Attendance') {
										const isTeacher = stat.label.toLowerCase().includes('teacher');
										const clickHandler = isTeacher ? handleTeacherClick : handleStudentClick;

										return (
											<div
												key={sidx}
												className="flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center border border-white/20 cursor-pointer hover:bg-white/20 transition-all duration-300"
												onClick={clickHandler}
											>
												{isLoading ? (
													<div className="flex items-center justify-center h-8">
														<KVSLoader size={20} />
													</div>
												) : (
													<div className="font-bold text-white text-xl drop-shadow-md">{stat.value}</div>
												)}
												<div className="text-white/80 text-xs mt-1 font-medium">{stat.label}</div>
											</div>
										);
									}
									return (
										<div
											key={sidx}
											className="flex-1 bg-white/10 backdrop-blur-sm rounded-xl p-3 text-center border border-white/20"
										>
											{isLoading ? (
												<div className="flex items-center justify-center h-8">
													<KVSLoader size={20} />
												</div>
											) : (
												<div className="font-bold text-white text-xl drop-shadow-md">{stat.value}</div>
											)}
											<div className="text-white/80 text-xs mt-1 font-medium">{stat.label}</div>
										</div>
									);
								})}
							</div>
							
							{/* Only show button if not Attendance card */}
							{card.title !== 'Attendance' && (
								<button
									className="mt-auto w-[85%] max-w-full py-3 rounded-xl bg-white/10 text-white font-semibold text-sm md:text-base border border-white/30 backdrop-blur-md hover:bg-white hover:text-gray-900 shadow-lg transform transition-all duration-300 active:scale-95 z-10"
									onClick={card.title === 'Student Performance' ? handleStudentPerformanceClick : () => navigate(card.route)}
								>
									{card.button}
								</button>
							)}
						</div>
					))}
				</div>
			</section>
			<Footer />
		</div>
	);
}
